const actionTypes = require('constants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');

const getCardsPaymentCycleRequest = () => ({
    type: actionTypes.CARDS_PAYMENT_CYCLE_REQUEST
});

const getCardsPaymentCycleFailure = error => ({
    type: actionTypes.CARDS_PAYMENT_CYCLE_FAILURE,
    payload: {
        error
    }
});

const getCardsPaymentCycleSuccess = data => ({
    type: actionTypes.CARDS_PAYMENT_CYCLE_SUCCESS,
    payload: {
        data
    }
});

const getCardsPaymentCycle = (immCard) => (dispatch) => {
    const productSubType = immCard.get('productSubType');
    const product = immCard.get('newProduct');

    const requestData = {
        query: {
            type: product,
            subType: productSubType
        }
    };
    dispatch(getCardsPaymentCycleRequest());
    return APIGet({
        dispatch,
        endpoint: 'cardPaymenyCycle',
        params: requestData
    })
        .then(response => {
            dispatch(getCardsPaymentCycleSuccess(response));
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(getCardsPaymentCycleFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getCardsPaymentCycle
}
